function gtag(){window.dataLayer.push(arguments)}function getCookie(e){const t=e+"=",a=document.cookie.split(";");for(let e=0;e<a.length;e++){let n=a[e];for(;" "===n.charAt(0);)n=n.substring(1,n.length);if(0===n.indexOf(t))return JSON.parse(decodeURIComponent(n.substring(t.length,n.length)))}return{}}

const features=[{name:"consent-tracking-api",version:"0.1"}];
window.dataLayer=window.dataLayer||[];
window.AVADA_COOKIES_BAR=window.AVADA_COOKIES_BAR||{};
window.AVADA_COOKIE_CONSENT=getCookie("avada_cookie_consent");

let initialConsent=window.AVADA_COOKIE_CONSENT;
if(!Object.keys(initialConsent).length){initialConsent={marketing:false,analytics:false,functional:false}}

// Intercept dataLayer.push to block any async script (e.g. Google & YouTube Sales Channel)
// from overriding consent defaults to 'granted'. The G&Y channel injects a Script Tag that
// fires gtag('consent','default',{all:'granted'}) after this script runs. The interceptor
// catches that push synchronously and rewrites the values to match the stored cookie state
// before Google's gtag library ever reads them — preventing the gcs=G111 data leak.
(function(){
  const _push=window.dataLayer.push;
  window.dataLayer.push=function(){
    for(let i=0;i<arguments.length;i++){
      const arg=arguments[i];
      if(arg&&arg[0]==="consent"&&arg[1]==="default"&&arg[2]){
        arg[2].ad_storage          =initialConsent.marketing ?"granted":"denied";
        arg[2].ad_user_data        =initialConsent.marketing ?"granted":"denied";
        arg[2].ad_personalization  =initialConsent.marketing ?"granted":"denied";
        arg[2].analytics_storage   =initialConsent.analytics ?"granted":"denied";
        arg[2].functionality_storage  =initialConsent.functional?"granted":"denied";
        arg[2].personalization_storage=initialConsent.functional?"granted":"denied";
      }
    }
    return _push.apply(this,arguments);
  };
})();

window.Shopify?.loadFeatures&&window.Shopify.loadFeatures(features,(err=>{
  if(err){console.error("Failed to load features",err);return}
  let c=window.AVADA_COOKIE_CONSENT;
  if(!Object.keys(c).length){c={marketing:false,analytics:false,functional:false}}
  window.Shopify.customerPrivacy.setTrackingConsent({analytics:c.analytics,marketing:c.marketing,preferences:c.functional},function(e){if(e)console.error("Shopify consent error",e)})
}));

(()=>{
  const e=initialConsent;
  if(!e.marketing)gtag("set","ads_data_redaction",true);
  gtag("set","url_passthrough",true);
  gtag("consent","default",{ad_storage:e.marketing?"granted":"denied",ad_user_data:e.marketing?"granted":"denied",ad_personalization:e.marketing?"granted":"denied",analytics_storage:e.analytics?"granted":"denied",functionality_storage:e.functional?"granted":"denied",personalization_storage:e.functional?"granted":"denied",security_storage:"granted",wait_for_update:500});
})();

document.addEventListener("visitorConsentCollected",(function(e){
  const t=e.detail||{};
  gtag("set","ads_data_redaction",!t.marketingAllowed);
  gtag("consent","update",{ad_storage:t.marketingAllowed?"granted":"denied",ad_user_data:t.marketingAllowed?"granted":"denied",ad_personalization:t.marketingAllowed?"granted":"denied",analytics_storage:t.analyticsAllowed?"granted":"denied",functionality_storage:t.preferencesAllowed?"granted":"denied",personalization_storage:t.preferencesAllowed?"granted":"denied",security_storage:"granted"});
}));
